import "./horoscop.css";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import axios from "axios";
import { GetAllWidgethoroscop } from "../../../redux/action/Widgets/widgetActions";

const Horoscopeswidgets = () => {
  const [allSigns, setAllSigns] = useState([
    "Aries",
    "Taurus",
    "Gemini",
    "Cancer",
    "Leo",
    "Virgo",
    "Libra",
    "Scorpio",
    "Sagittarius",
    "Capricorn",
    "Aquarius",
    "Pisces",
  ]);
  const [allSignsData, setAllSignsData] = useState([
    { description: "", mood: "", luky_time: "" },
    { description: "", mood: "", luky_time: "" },
    { description: "", mood: "", luky_time: "" },
    { description: "", mood: "", luky_time: "" },
    { description: "", mood: "", luky_time: "" },
    { description: "", mood: "", luky_time: "" },
    { description: "", mood: "", luky_time: "" },
    { description: "", mood: "", luky_time: "" },
    { description: "", mood: "", luky_time: "" },
    { description: "", mood: "", luky_time: "" },
    { description: "", mood: "", luky_time: "" },
    { description: "", mood: "", luky_time: "" },
  ]);
  const [token, setToken] = useState("");
  const [endpoint, setEndpoint] = useState("");
  const [api_host, setApi_host] = useState("");
  const [isloading, setisLoading] = useState(true);
  const dispatch = useDispatch();

  const prepareCridatials = (ch, widgetsList) => {
    const WeatherCredentials = widgetsList
      ?.filter((ele) => ele.name === "Horoscope")[0]
      .widgets?.filter((ele) => ele.is_reachebale)[0];

    setToken(WeatherCredentials.Token);
    setEndpoint(WeatherCredentials.endPoint);
    setApi_host(WeatherCredentials.api_host);
  };

  useEffect(async () => {
    GetAllWidgethoroscop(dispatch, setData);
  }, []);

  const setData = (data) => {
    const credentials = data
      ?.filter((ele) => ele.name === "horoscope")[0]
      .widgets?.filter((ele) => ele.is_reachebale)[0];
    getALl(credentials).then((res) => {
      setAllSignsData(() => res);
    });
  };

  const getALl = async (data) => {
    setisLoading(true);
    const credentials = data;
    const res = await Promise.all(
      allSigns.map(async (ele, i) => {
        try {
          const horoItem = await fetchHoroscop(() => options(ele, credentials));
          return horoItem.data;
        } catch (err) {}
      })
    );
    setisLoading(false);

    return res;
  };

  const options = (astrodSign, credentials) => {
    return {
      method: "POST",
      url: `${credentials.endPoint}`,
      params: { sign: astrodSign, day: "today" },
      headers: {
        "X-RapidAPI-Key": `${credentials.Token}`,
        "X-RapidAPI-Host": `${credentials.api_host}`,
      },
    };
  };

  const fetchHoroscop = async (option) => {
    const data = await axios.request(option());
    return data;
  };

  const horoscopList = [
    "Aries",
    "Taurus",
    "Gemini",
    "Cancer",
    "Leo",
    "Virgo",
    "Libra",
    "Scorpio",
    "Sagittarius",
    "Capricorn",
    "Aquarius",
    "Pisces",
  ];

  const { t } = useTranslation();
  return (
    <>

      <section className="single-banner">
        <div className="container__">
          <div className="row">
            <div className="col-lg-12">
              <div className="single-content">
                <h2>horoscope</h2>
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/">{t("Home")}</Link>
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </section>

      {isloading ? (
        <div className="loadingHoroscope">
          <img src="https://cdn.pixabay.com/animation/2022/10/11/03/16/03-16-39-160_512.gif" />
        </div>
      ) : (
        <div className="horoscopContainer">
          {horoscopList.map((ele, i) => (
            <div className="horoscopItemContainer" key={"horoscope" + i}>
              <img
                src={`https://icons.iconarchive.com/icons/icons-land/flat-zodiac/64/${ele}-icon.png`}
              />
              <h4>{ele}</h4>
              <div className="itemInfo">
                <h4 className="itemdesTitle">{t("description")}</h4>{" "}
                <p className="itemtitleinfo">{allSignsData[i]?.description}</p>
                <h4 className="itemdesTitle">{t("mood")}</h4>
                <p className="itemtitleinfo"> {allSignsData[i]?.mood} </p>
                <h4 className="itemdesTitle">{t("lucky time")}</h4>
                <p className="itemtitleinfo">{allSignsData[i]?.lucky_time} </p>
                <h4 className="itemdesTitle">{t("color")}</h4>
                <p className="itemtitleinfo">{allSignsData[i]?.color} </p>
              </div>
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default Horoscopeswidgets;
